"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var react_1 = __importDefault(require("react"));
exports.default = (function (_a) {
    var TreeNode = _a.TreeNode, _b = _a.data, data = _b === void 0 ? {} : _b, onUpdateData = _a.onUpdateData, onTreeEvent = _a.onTreeEvent, Template = _a.Template, _c = _a.path, path = _c === void 0 ? '' : _c, deleteChildAt = _a.deleteChildAt, updateMyData = _a.updateMyData;
    if (!data.children) {
        return [];
    }
    var pathPrifix = path ? path + "." : '';
    return data.children.map(function (data, i) {
        return (react_1.default.createElement(TreeNode, { data: data, onUpdateData: onUpdateData, onTreeEvent: onTreeEvent, onDelete: function () { return deleteChildAt(i); }, onUpdateParent: updateMyData, Template: Template, path: pathPrifix + "children." + i, i: i }));
    });
});
